import { createAsyncReducer } from '../../standard-actions/reducers';
import { ILoadIncidentsAction, ILoadIncidentsSuccessAction } from '../actions/load-all-incidents/load-all-incidents';
import { ILoadIncidentsErrorAction } from '../actions/load-all-incidents/load-all-incidents-error';
import { ITicketsState } from '../state';
import { initialState } from './initial-state';

export type TicketsAction
    = ILoadIncidentsAction
    | ILoadIncidentsSuccessAction
    | ILoadIncidentsErrorAction;

const init = (state: ITicketsState, action: TicketsAction) => ({
    ...state,
    incidents: {
        items: [],
        status: action.status,
    }
});

const success = (state: ITicketsState, action: TicketsAction) => ({
    ...state,
    incidents: {
        items: (action as ILoadIncidentsSuccessAction).items,
        pagination: (action as ILoadIncidentsSuccessAction).pagination,
        status: action.status
    }
});

const failure = (state: ITicketsState, action: TicketsAction) => ({
    ...state,
    incidents: {
        items: [],
        status: action.status,
        error: (action as ILoadIncidentsErrorAction).error
    }
});

export const incidentsReducer = createAsyncReducer(initialState, init, success, failure);
